import { Skeleton } from "@mui/material";

import { PageBreadcrumbs } from "@/shared/components";
import { useFileSuspense } from "@/shared/domain/files/hooks";

import { FileParentAssociation } from "./FileParentAssociation";
import { FilePath } from "./FilePath";
import styles from "./FileSource.module.css";

interface FileSourceProps {
  /** The active fileId */
  fileId: string;
}

/**
 * UI for displaying where the file originated from
 */
export function FileSource(props: FileSourceProps) {
  const fileQuery = useFileSuspense(props.fileId);

  return (
    <PageBreadcrumbs>
      <div className={styles.truncateText}>
        <FileParentAssociation fileRecord={fileQuery.data} />
      </div>
      <FilePath fileRecord={fileQuery.data} />
    </PageBreadcrumbs>
  );
}

export function FileSourceSkeleton() {
  return (
    <PageBreadcrumbs>
      <Skeleton animation="wave" variant="text" width="200px" />
      <Skeleton animation="wave" variant="text" width="160px" />
    </PageBreadcrumbs>
  );
}
